/**
 * Labstep
 *
 * @module components/OrderRequest/Card/Overview
 * @desc Overview Card for order requests
 */

import { EntityCardOverview } from 'labstep-web/components/Entity/Card/Overview';
import { OrderRequestActionCreate } from 'labstep-web/components/OrderRequest/Action/Create';
import { OrderRequestActionMenu } from 'labstep-web/components/OrderRequest/Action/Menu';
import { OrderRequestEmptyState } from 'labstep-web/components/OrderRequest/EmptyState';
import { Action } from 'labstep-web/components/ResourceItem/Action/Menu';
import { ICONS } from 'labstep-web/constants/icons';
import { OrderRequest } from 'labstep-web/models/order-request.model';
import type React from 'react';
import type { OrderRequestCardOverviewProps } from './types';

export const OrderRequestCardOverview: React.FC<
  OrderRequestCardOverviewProps
> = ({ params }) => (
  <EntityCardOverview
    emptyState={<OrderRequestEmptyState />}
    entityName={OrderRequest.entityName}
    icon={ICONS.order_request.primary}
    actionMenu={({ entity }) => (
      <OrderRequestActionMenu
        orderRequest={entity as OrderRequest}
        actions={[Action.duplicate, Action.delete]}
      />
    )}
    action={<OrderRequestActionCreate />}
    params={{ ...params, is_template: false, status: 'new' }}
    title="New Order Requests"
  />
);
